import '..//..//..//mixins.js'
import { mapGetters, mapActions, mapState } from 'vuex'
import spinner from "../../LoadingComponent/LoadingComponent.vue"
//import Plotly from 'plotly.js-basic-dist-min'
var Plotly = require('./../../../custom_bundles/custom-plotly.js');

export default {
  name: 'performance',
  components: {
    spinner
  },
  data() {
    return {
      responseData : null,
      selected:'',
      benchmarks: [] ,
      benchmark_data: null,
      benchmarkIsin: null,
      days: -1,
      benchmarkOption: false,
      portfolio_id : this.$route.params.PORTFOLIO_ID,
      PortfolioEmpty: false,
      PERFORMANCE_THRESHOLD: 4,
      timeOption: false,
      riskOption: false,
      stockData: {
        dates: []
      },
      userDividends: [],
      dividendOption: false,
      dividendYears: [],
      latestDividendYear: "",
      showPerformanceSpinner: false,
      isEndpointError: false,
      correlation: null,
      correlationVisible:false
    }
  },
  async created(){
    this.showSpinner = true;
  },
  beforeMount(){
    this.portfolioBenchmark = this.get_PD_userData
    this.stockData = {name: 'Portfolio', dates: this.portfolioBenchmark.date, prices: this.portfolioBenchmark.indexed_net_portfolio_values, index_benchmark: this.portfolioBenchmark.index_benchmark};
  },
  async mounted () {

    if(this.stockData.dates){
      this.plotPortfolioValue( -1, 'chart');
      var currButt = document.getElementById(-1);
      currButt.className = "chart_time active";
    }else{
      this.isPortfolioEmpty = true
    }
    
    window.addEventListener("resize", this.myEventHandler);
    this.buttonActivation("nav-bar-plot", "btn")
  }, 
  computed: {
    ...mapGetters(['get_PD_userData']),
    ...mapState(['PD_userData'])

  },
  watch: {
      PD_userData:function(newVal){
      if(newVal !=this.portfolioBenchmark){
        this.portfolioBenchmark = newVal;
        this.stockData = {name: 'Portfolio', dates: this.portfolioBenchmark.date, prices: this.portfolioBenchmark.indexed_net_portfolio_values, index_benchmark: this.portfolioBenchmark.index_benchmark};
        this.benchmarks = [];
        if(this.stockData.dates){
          setTimeout(() => this.PortfolioEmpty = false, 1000)
          this.buttonActivation("nav-bar-plot", "btn")
          this.plotPortfolioValue( -1, 'chart');
        }
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    ...mapActions(['load_PD_userData']),
      normalizeValues: function(stockPrices) {
        var i;
        var normalized_values = [];  
      for (i = 0; i < stockPrices.length; i++) {
        normalized_values.push(100*stockPrices[i]/stockPrices[0]);
      }
    return normalized_values;
    
    },
    loadData: async function() {
    },
    myEventHandler() {
      this.plotActiveTimeSeries(this.days)
    },
    plotPortfolioDividends: function(chart_div){
      this.timeOption = false;
      this.benchmarkOption = false;
      this.riskOption = false;
      this.correlationVisible = false;
      var dividendsMonthly = this.get_PD_userData['dividend_payments']['net_dividend_payments']
      let rawDates = dividendsMonthly['date']
      this.dividendYears = this.getUniqueYearsFromList(rawDates)
      if(this.latestDividendYear.length < 1){
        this.latestDividendYear = this.dividendYears[this.dividendYears.length - 1]
      }
      this.dividendOption = true;
      var data = []
      var dates = []

      
      var activeYear = document.getElementById("dividend-selector").value;
      if (activeYear == null || activeYear.length < 1){
        activeYear = this.latestDividendYear
      }
      for (var dateIndex in rawDates){
        dates.push(rawDates[dateIndex].substring(0,7))
      }


      var currentIndices = []
      for(var i=0;i < dates.length; i++){
        console.log(activeYear)
        if(dates[i].indexOf(activeYear) !=-1) {
          currentIndices.push(i)
          }
    
    }
    let ci_length = currentIndices.length

      var trace = []
      for (var key in dividendsMonthly) {
        if(key != 'date'){
          trace = {
            x: dates.slice(currentIndices[0], currentIndices[ci_length-1] + 1),
            y: dividendsMonthly[key].slice(currentIndices[0], currentIndices[ci_length-1] + 1),
            name: key,
            type: 'bar',
            hovertemplate: 'Dividende: €%{y:.2f}'
          };
          data.push(trace)
        }
    }  
    var layout = {}

    if (window.innerWidth <= 900){
      layout = {
        barmode: 'stack',
        title: 'Dividenden ' + activeYear,
        margin:{
          'l':45,
          'r':25,
          'b':40,
          't':40,
          'pad':0
        },
        legend:{'font': {'color': 'black'}, 'bgcolor': 'rgba(0,0,0,0)', "orientation": "h", y: -0.5},
        xaxis: {'color': 'black','gridcolor': 'rgba(0,0,0,0)', fixedrange: true, tickformat: '%b %Y', type: 'date', tickvals: dates.slice(currentIndices[0], currentIndices[ci_length])},
        yaxis:{'color': 'black','gridcolor': '#rgba(0,0,0,0)',  tickformat: ',.0€', title:'Dividende (€)', fixedrange: true},
        colorway : ['#FFD2B9', '#FFC7A9', '#FFB48B','#FFA878', '#FF955C','#FF7D37' ,'#FF6816','#E0601A' ,'#C2581F','#AD5322','#994E25','#854827','#70432A' ,'#5C3E2D','#333333'  ],
      };
    }else{
      layout = {
        barmode: 'stack',
        title: 'Dividenden ' + activeYear,
        margin:{
          'l':45,
          'r':25,
          'b':40,
          't':40,
          'pad':0
        },
        xaxis: {'color': 'black','gridcolor': 'rgba(0,0,0,0)', fixedrange: true, tickformat: '%b %Y', type: 'date', tickvals: dates.slice(currentIndices[0], currentIndices[ci_length])},
        yaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)',  tickformat: ',.0€', title:'Dividende (€)', fixedrange: true},
        showlegend: false,
        colorway : ['#FFD2B9', '#FFC7A9', '#FFB48B','#FFA878', '#FF955C','#FF7D37' ,'#FF6816','#E0601A' ,'#C2581F','#AD5322','#994E25','#854827','#70432A' ,'#5C3E2D','#333333'  ],
      };
    }

      
      Plotly.newPlot(chart_div, data, layout);
    },
    plotActiveTimeSeries: async function(days) {


      this.days = days;
      if(document.getElementById('return_evolution').classList.contains("active"))
      {
        this.plotReturnEvolution(days, 'chart');
      }
      else{
        if(document.getElementById('value_evolution').classList.contains("active"))
        {
          this.plotPortfolioValue(days, 'chart');
        }
        else{
          if(document.getElementById('portfolio_risk').classList.contains("active"))
          {
            this.plotPortfolioRisk(days, 'chart');
          }else{
            this.plotPortfolioDividends('chart')
          }
          

        }
      }
    },

    plotPortfolioValue: async function(days, divName) {
        
      var days_options = [30, 180, 365, -1];
      var current;
      var i;
      for (i = 0; i < days_options.length; i++) {
          current = document.getElementById(days_options[i]);
        if(days == days_options[i])
        {
           current.className = "chart_time active";
        }
        else{
          current.className ="chart_time";
        }

      }


      this.benchmarkOption = false;
      this.timeOption = true;
      this.riskOption = false;
      this.dividendOption = false;
      this.correlationVisible = false;
      var stockName = this.portfolioBenchmark.name;
      
      var stockDatesTotal = this.portfolioBenchmark.date;
      var stockDataTotal = this.portfolioBenchmark.portfolio_values;

      if (days != -1){
        stockDatesTotal = stockDatesTotal.slice(Math.max(stockDatesTotal.length - days, 0))
        stockDataTotal = stockDataTotal.slice(Math.max(stockDataTotal.length - days, 0))
      }


      var stock = {
        x:stockDatesTotal,
        y:stockDataTotal,
        mode:'lines',
        line:{'width':3, color:'#FF6816'},
  
        opacity:1,
        name: stockName,
        hovertemplate: '%{y} €<extra></extra>'

      }
          var data_prices =[stock];
  
          var layout_prices = {
            paper_bgcolor:'rgba(0,0,0,0)',
            plot_bgcolor:'rgba(0,0,0,0)',
            hovermode:'x',
            autosize:true,
            legend:{'font': {'color': 'black'}, 'bgcolor': 'rgba(0,0,0,0)'},
            xaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)', fixedrange: true, 'ticksuffix': ' ', 'automargin':true,'tickformat': '%d.%m.%Y'},
            yaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)', title: "Depotwert (€)",fixedrange: true},
            margin:{
              'l':60,
              'r':25,
              'b':20,
              't':20,
              'pad':4
          },

          };
          var config = {
            displayModeBar: false,
          };
          
          Plotly.newPlot(divName, data_prices, layout_prices, config);
    },

    plotReturnEvolution: async function(days, divName) {
      Plotly.purge(divName)
      this.showPerformanceSpinner = true;

      var days_options = [30, 180, 365, -1];
      var current;
      var i;
      for (i = 0; i < days_options.length; i++) {
          current = document.getElementById(days_options[i]);
        if(days == days_options[i])
        {
           current.className = "chart_time active";
        }
        else{
          current.className ="chart_time";
        }

      }

 //     try{
        if (this.benchmark_data == null){
          var payload = {"portfolio_id":this.portfolio_id, first_date: this.stockData.dates[0]};
          this.benchmark_data = await this.postEndpoint(payload, "benchmarkPortfolios/?format=json")      
        }
        if(this.benchmarkIsin == null){
          this.addBenchmarks();
        }else{
          //this.benchmarkIsin = document.getElementById("benchmark-selector").value;
        }
        console.log("isin:", this.benchmarkIsin)
  
        this.benchmarkOption = true;
        this.timeOption = true;
        this.riskOption = false;
        this.dividendOption = false;
  
        this.days = days;
          var benchmarkName = this.benchmark_data["index_benchmark_prices"][this.benchmarkIsin]["name"] // structure allows for multiple benchmarks in future
          var benchmarkDatesTotal = this.benchmark_data["index_benchmark_prices"][this.benchmarkIsin]["dates"];
          var benchmarkDataTotal = this.benchmark_data["index_benchmark_prices"][this.benchmarkIsin]["prices"];
          
          var day_key;
          switch(days){
            case 30:
              day_key = "1m";
              break; 
            case 180:
              day_key = "6m";
              break; 
            case 365:
              day_key = "1y";
              break; 
            default:
              day_key = "total";
          }
          
          this.correlation = this.benchmark_data["correlations"][this.benchmarkIsin][day_key]
          this.correlationVisible = true
  
        var stockName = this.stockData["name"]
        var stockDatesTotal = this.stockData["dates"];
        var stockDataTotal = this.stockData["prices"];
  
  
        // additional slicing
        if (days != -1){ // send -1 to request full horizon
          stockDatesTotal = stockDatesTotal.slice(Math.max(stockDatesTotal.length - days, 0))
          stockDataTotal = stockDataTotal.slice(Math.max(stockDataTotal.length - days, 0))
          benchmarkDatesTotal = benchmarkDatesTotal.slice(Math.max(benchmarkDatesTotal.length - stockDatesTotal.length, 0)) // condition on portfolio length
          benchmarkDataTotal = benchmarkDataTotal.slice(Math.max(benchmarkDataTotal.length - stockDataTotal.length, 0))
        }
  
        else{
        // ensures that the total amount shown is restricted to length of the respective security
        benchmarkDatesTotal = benchmarkDatesTotal.slice(Math.max(benchmarkDatesTotal.length - stockDatesTotal.length, 0))
        benchmarkDataTotal = benchmarkDataTotal.slice(Math.max(benchmarkDataTotal.length - stockDataTotal.length, 0))
  
  }
  
        // normalize the data
        stockDataTotal = this.normalizeValues(stockDataTotal);
        benchmarkDataTotal = this.normalizeValues(benchmarkDataTotal);
  
        var stock = {
          x:stockDatesTotal,
          y:stockDataTotal,
          type:'lines',
          line:{'width':3, color:'#FF6816'},
    
          opacity:1,
          name: stockName
  
        };
        var benchmark = {
          x:benchmarkDatesTotal,
          y:benchmarkDataTotal,
          type:'lines',
          line:{'width':3, color:'#333333'},
          opacity:1,
          name:benchmarkName,
          
  
        };
    
    
            var data_prices = [stock, benchmark];
            var graphTitle;
            switch(this.days){
              case 30:
                graphTitle = 'Portfolioentwicklung (Letzter Monat)';
                break; 
              case 180:
                graphTitle = 'Portfolioentwicklung (Letzte 6 Monate)';
                break; 
              case 365:
                graphTitle = 'Portfolioentwicklung (Letztes Jahr)';
                break; 
              case 1095:
                graphTitle = 'Portfolioentwicklung (Letzte 3 Jahre)';
                break; 
              case -1:
                graphTitle = 'Portfolioentwicklung (Total)';
                break; 
            }
  
            var layout_prices = {
              title : graphTitle,
              paper_bgcolor:'#FFFFFF',
              plot_bgcolor:'#FFFFFF',
              hovermode:'x',
              autosize:true,
              legend:{'font': {'color': 'black'}, 'bgcolor': '#FFFFFF', "orientation": "h", y: -0.5},
              xaxis:{'color': 'black','gridcolor': '#FFFFFF', fixedrange: true},
              yaxis:{'color': 'black','gridcolor': '#EDEDED', fixedrange: true},
              margin:{
                'l':45,
                'r':25,
                'b':20,
                't':40,
                'pad':2
            },
  
            };
        
            var config = {
              displayModeBar: false,
            };
            this.showPerformanceSpinner = false;
            Plotly.newPlot(divName, data_prices, layout_prices, config);
  //    }
  //    catch{
  //      this.showErrorNotification('performance')
  //    }
      
    },
    async plotPortfolioRisk(days, divName) {
      Plotly.purge(divName)
      this.showPerformanceSpinner = true; 

      var days_options = [30, 180, 365, -1];
      var current;
      var i;
      for (i = 0; i < days_options.length; i++) {
          current = document.getElementById(days_options[i]);
        if(days == days_options[i])
        {
           current.className = "chart_time active";
        }
        else{
          current.className ="chart_time";
        }

      }

      console.log("risk plot")
      this.benchmarkOption = false;
      this.riskOption = true;
      this.dividendOption = false;
      var day_key;
      this.correlationVisible = false;

      switch(days){
        case 30:
          day_key = "1m";
          break; 
        case 180:
          day_key = "6m";
          break; 
        case 365:
          day_key = "1y";
          break; 
        default:
          day_key = "total";
      }

//      try{
        if (this.benchmark_data == null){
          var payload = {"portfolio_id":this.portfolio_id, first_date: this.stockData.dates[0]};
          this.benchmark_data = await this.postEndpoint(payload, "benchmarkPortfolios/?format=json")
          this.addBenchmarks();
        }
        var PortfolioReturns = this.benchmark_data["user_benchmarks"]["portfolio_return"][day_key];
        var PortfolioVolatility = this.benchmark_data["user_benchmarks"]["portfolio_volatility"][day_key];
        
        var benchmarkPortfolioReturns = PortfolioReturns.slice(1);
        var benchmarkPortfolioVolatility = PortfolioVolatility.slice(1);

        var portfolioReturn =  PortfolioReturns[0]; // as given in percentage points
        var portfolioVolatility =  PortfolioVolatility[0]; // as given in percentage points
        
        var indexReturns =  this.benchmark_data["index_benchmarks"]["portfolio_return"][day_key]; // as given in percentage points
        var indexVolas =  this.benchmark_data["index_benchmarks"]["portfolio_volatility"][day_key]; // as given in percentage points
        var indexNames =  this.benchmark_data["index_benchmarks"]["names"]; // as given in percentage points

    
        var volatilities_bm = {
          x:benchmarkPortfolioVolatility,
          y:benchmarkPortfolioReturns,
          type:'scatter',
          mode: 'markers',
          opacity:1,
          hovertemplate : "Rendite: %{y}<br>Volatilität: %{x}<extra></extra> ",
          marker: {
            color: ['#333333'],
            size: 12
          }
          ,
          hover_data:["portfolio"]
        };

        var volatilities_user = {
          x:[portfolioVolatility],
          y:[portfolioReturn],
          type:'scatter',
          mode: 'markers',
          opacity:1,
          hovertemplate : "Rendite: %{y}<br>Volatilität: %{x}<extra></extra> ",
          marker: {
            color: ['#FF6816'],
            size: 12
          }
          ,
          hover_data:["portfolio"]
        };

        var index_benchmarks = {
          x:indexVolas,
          y:indexReturns,
          type:'scatter',
          mode: 'markers',
          opacity:0.5,
          text : indexNames,
          hovertemplate : "%{text} <br>Rendite: %{y}<br>Volatilität: %{x}<extra></extra> ",
          hoverinfo:"x+y",
          marker: {
            color: ['#333333'],
            size: 12,
            symbol: 'x'
          }

        };
        var max_vola = Math.max.apply(Math, indexVolas.concat(portfolioVolatility, benchmarkPortfolioVolatility)) + 0.025
        var data_prices = [volatilities_bm, index_benchmarks, volatilities_user];
    
            var layout_prices = {
              paper_bgcolor:'rgba(0,0,0,0)',
              plot_bgcolor:'rgba(0,0,0,0)',
              hovermode:'closest',
              hovertemplate: '<extra></extra>',
              autosize:true,
              showlegend:false,
              xaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)',  tickformat: ',.2%', title:'Jahresvolatilität', fixedrange: true, range:[0, max_vola]},
              yaxis:{'color': 'black','gridcolor': 'rgba(0,0,0,0)',  tickformat: ',.2%', title:'Rendite', fixedrange: true},
              margin:{
                'l':80,
                'r':25,
                'b':40,
                't':25,
                'pad':2
            },

            };
        
            var config = {
              displayModeBar: false,
            };
            this.showPerformanceSpinner = false;

  
            Plotly.newPlot(divName, data_prices, layout_prices, config);
//      }
//      catch{
//        this.showErrorNotification('performance')
//      }
      
    
    },
  }
}